<se-fe-chip-group class="open-registration-filter">
  <se-fe-chip
    [seFeDataText]="sportChipText"
    seFeDataIconRight="chevron_down"
    [seFeDataSelected]="hasSelectedValues(selectedSportIds)"
    [seFeMenuTrigger]="sportMenu">
  </se-fe-chip>

  <se-fe-chip
    [seFeDataText]="organizationChipText"
    seFeDataIconRight="chevron_down"
    [seFeDataSelected]="hasSelectedValues(selectedOrganizationIds)"
    [seFeMenuTrigger]="organizationMenu">
  </se-fe-chip>

  <se-fe-chip
    [seFeDataText]="typeChipText"
    seFeDataIconRight="chevron_down"
    [seFeDataSelected]="hasSelectedValues(selectedTypeIds)"
    [seFeMenuTrigger]="typeMenu">
  </se-fe-chip>
</se-fe-chip-group>

<se-fe-menu-filter #sportMenu [seFeDataOptions]="sportMenuOptions">
  <div seFeMenuContent class="open-registration-filter__menu-content">
    <form [formGroup]="filtersForm" novalidate>
      <se-fe-list formGroupName="sport">
        @for (sport of sports; track sport.id) {
        <se-fe-list-item class="open-registration-filter__checkbox-row">
          <se-fe-checkbox
            [formControlName]="sport.id"
            [seFeDataOptions]="sportCheckboxOptions[sport.id]">
          </se-fe-checkbox>
        </se-fe-list-item>
        }
      </se-fe-list>
    </form>
  </div>
</se-fe-menu-filter>

<se-fe-menu-filter #organizationMenu [seFeDataOptions]="organizationMenuOptions">
  <div seFeMenuContent class="open-registration-filter__menu-content">
    <form [formGroup]="filtersForm" novalidate>
      <se-fe-list formGroupName="organization">
        @for (organization of organizations; track organization.id) {
        <se-fe-list-item class="open-registration-filter__checkbox-row">
          <se-fe-checkbox
            [formControlName]="organization.id"
            [seFeDataOptions]="organizationCheckboxOptions[organization.id]">
          </se-fe-checkbox>
        </se-fe-list-item>
        }
      </se-fe-list>
    </form>
  </div>
</se-fe-menu-filter>

<se-fe-menu-filter #typeMenu [seFeDataOptions]="typeMenuOptions">
  <div seFeMenuContent class="open-registration-filter__menu-content">
    <form [formGroup]="filtersForm" novalidate>
      <se-fe-list formGroupName="type">
        @for (type of signupTypeList; track type.id) {
        <se-fe-list-item class="open-registration-filter__checkbox-row">
          <se-fe-checkbox
            [formControlName]="type.id"
            [seFeDataOptions]="typeCheckboxOptions[type.id]">
          </se-fe-checkbox>
        </se-fe-list-item>
        }
      </se-fe-list>
    </form>
  </div>
</se-fe-menu-filter>
